export const buttons: Record<string, { label: string; shortcut: string | undefined }> = {
    'add-vertex-button': {
        label: '+Vertex',
        shortcut: 'V',
    },
    'add-edge-button': {
        label: '+Edge',
        shortcut: 'E',
    },
    'splitpatch-button': {
        label: 'Split',
        shortcut: 'S',
    },
    'carve-button': {
        label: 'Carve',
        shortcut: 'C',
    },
    'offset-button': {
        label: 'Offse',
        shortcut: 'O',
    },
    'merge-faces-button': {
        label: 'Dissolve',
        shortcut: undefined,
    },
    'delete-objects-button': {
        label: 'Delete',
        shortcut: undefined,
    },
    'invisible-button': {
        label: 'Invisible',
        shortcut: undefined,
    },
    'fix-objects-button': {
        label: 'Fix',
        shortcut: 'X',
    },
    'rigid-move-button': {
        label: 'Move',
        shortcut: 'M',
    },
    'scale-button': {
        label: 'Scale',
        shortcut: 'D',
    },
    'set-vertex-xyz-button': {
        label: 'Place',
        shortcut: undefined,
    },
    'project-edges-button': {
        label: 'Project',
        shortcut: undefined,
    },
    'snap-to-object-button': {
        label: 'Snap',
        shortcut: 'N',
    },
    'start-attaching-to-stl-button': {
        label: 'to STL',
        shortcut: undefined,
    },
    'popout-button': {
        label: 'Popout',
        shortcut: 'P',
    },
    'popin-button': {
        label: 'Popin',
        shortcut: undefined,
    },
    'popout-cut-button': {
        label: 'Thicken',
        shortcut: undefined,
    },
    'hole-button': {
        label: 'Hole',
        shortcut: undefined,
    },
    'handle-button': {
        label: 'Bridge',
        shortcut: undefined,
    },
    'stitch-button': {
        label: 'Stitch',
        shortcut: undefined,
    },
    'flatten-face-button': {
        label: 'Flatten',
        shortcut: undefined,
    },
    'make-edge-linear-button': {
        label: 'Linear',
        shortcut: 'L',
    },
    'make-circular-button': {
        label: 'Circular',
        shortcut: undefined,
    },
    'make-circular-exact-button': {
        label: 'Circular+',
        shortcut: undefined,
    },
    'clone-body-button': {
        label: 'Copy',
        shortcut: '⌃C',
    },
    'clone-edge-button': {
        label: 'Copy',
        shortcut: '⌃C',
    },
    'edit-edge-tangent-mode-button': {
        label: 'Tangent',
        shortcut: 'T',
    },
    'edit-edge-tangent-at-vertex-button': {
        label: 'Edit Tan',
        shortcut: 'M',
    },
    'fix-edge-tangent-at-vertex-button': {
        label: 'Lock Tan',
        shortcut: 'X',
    },
    'edge-to-face-tangency-button': {
        label: 'Tan → face',
        shortcut: undefined,
    },
    'edge-to-plane-perpendicular-button': {
        label: 'Normal',
        shortcut: undefined,
    },
    'edge-to-edge-tangent-parallel-button': {
        label: 'Copy tan',
        shortcut: undefined,
    },
    'smoothen-button': {
        label: 'Smooth',
        shortcut: 'U',
    },
    'unsmoothen-button': {
        label: 'Unsmooth',
        shortcut: undefined,
    },
    'mirror-button': {
        label: 'Mirror',
        shortcut: undefined,
    },
    'mirror-deghost-button': {
        label: 'Materialize',
        shortcut: undefined,
    },
    'set-symmetry-plane-button': {
        label: 'Symmetry',
        shortcut: undefined,
    },
    'symmetry-button': {
        label: 'Symmetry+',
        shortcut: 'Y',
    },
    'remove-from-symmetry-button': {
        label: 'Symmetry-',
        shortcut: undefined,
    },
};

export const button_selectors = Object.keys(buttons).map(x => '#' + x);
